// External
import React, { PureComponent } from 'react';

// Internal
import logo from "../../assets/images/logo.png";
import './styles.css';

/**
 * Renders accounts list items
 * @param {object[]} accounts
 * @param {Function} onItemSelected
 * @returns {Component[]}
 */
const renderAccountsItems = (accounts, onItemSelected) => {
  return accounts.map((account, index) => (
    <li key={ index } onClick={ () => onItemSelected(account) }><a href="#!">{ account.name }</a></li>
  ));
};

/**
 * Gets the selected account from a list of accounts.
 * @param {object[]} accounts
 * @returns {object}
 */
const getSelectedAccount = (accounts) => {
  return accounts.find(account => account.isSelected) || {};
};

const $ = window.$;

class NavBar extends PureComponent {
  componentDidMount() {
    if (this.props.accounts.length > 1) {
      $(".dropdown-trigger").dropdown(); // If we have more than one account, init the dropdown.
    }
  }

  render() {
    const { accounts, onItemSelected } = this.props;

    return (
      <div className="navbar-fixed">
        <ul id="dropdown-accounts" className="dropdown-content">
          { renderAccountsItems(accounts, onItemSelected) }
        </ul>
        <nav>
          <div className="nav-wrapper">
            <div>
              <img className="logo-image" src={ logo }/>
            </div>
            <div>
              <img className="logo-image" src={ getSelectedAccount(accounts).logo }/>
              <ul className="right hide-on-med-and-down">
                <li>
                  <a className="dropdown-trigger" href="#!"
                     data-target="dropdown-accounts">{ getSelectedAccount(accounts).name }{ accounts.length > 1 &&
                  <i className="material-icons right">arrow_drop_down</i> }</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/nav-bar/index.js